import React from 'react';

const IconLightningBolt = ({ ...styles }) => (
  <svg width="7" height="12" fill="currentColor" viewBox="0 0 7 12" {...styles} xmlns="http://www.w3.org/2000/svg">
    <path d="M6.47516 3.75H3.95081L4.88268 0.707813C4.97017 0.351563 4.71862 0 4.37518 0H1.22522C0.96272 0 0.739598 0.208594 0.704598 0.4875L0.00460634 6.1125C-0.0369557 6.45 0.208042 6.75 0.525225 6.75H3.12176L2.11333 11.3086C2.03458 11.6648 2.28833 12 2.62301 12C2.80676 12 2.98176 11.8969 3.07801 11.7188L6.92797 4.59375C7.1314 4.22109 6.87984 3.75 6.47516 3.75Z" />
  </svg>
);

export default IconLightningBolt;
